module.exports = __webpack_public_path__ + "static/media/wcolor_bg_04.3f98128d.png";